import React, { useState, useMemo, useEffect, useRef } from 'react';
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Button
} from 'reactstrap';

//redux
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ToastContainer } from 'react-toastify';

import withRouter from '../../components/Common/withRouter';
import TableContainer from '../../components/Common/TableContainer';
import Spinners from '../../components/Common/Spinner';
import { useAuthStore } from '../../zustand-store/auth.store';
import {
  getSerilizedCompletePaymentSearch,
  getSerilizedCompletePaymentLogs
} from '../../axios/paymentHistory/index';
import VerticalLayout from '../../components/VerticalLayout';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import JsonPreview from '../AdminAppointmentDetails/components/jsonPreview';
import { useNavigate } from 'react-router-dom';

// ✅ Import XLSX
import * as XLSX from 'xlsx';
const baseList = [10, 20, 40, 80, 100, 200, 300];

const formatDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}.${String(date.getMilliseconds()).padStart(3, '0')}`;

const getDefaultMonthRange = () => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999);
  return { startDate: formatDate(startOfMonth), endDate: formatDate(endOfMonth) };
};

const CompletePaymentLog = () => {
  //meta title
  document.title = 'Complete Payment logs | Seamless Slot';

  const navigate = useNavigate();
  const locationId = useAuthStore((state) => state.locationId);
  const defaultRange = getDefaultMonthRange();

  const [data, setData] = useState([]);
  const [prev, setPrev] = useState(null);
  const [next, setNext] = useState(null);
  const [startDate, setStartDate] = useState(defaultRange.startDate);
  const [endDate, setEndDate] = useState(defaultRange.endDate);
  const [filterValue, setFiletrValue] = useState('Month');
  const [showlist,setShowList]=useState([])
  const ContactsProperties = createSelector(
    (state) => state.contacts,
    (Contacts) => ({
      users: Contacts?.users,
      loading: Contacts?.loading
    })
  );

  const { loading } = useSelector(ContactsProperties);
  const [isLoading, setLoading] = useState(loading);
  const [loader, setLoader] = useState(false);

  const childRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [selectedPaymentLog, setSelectedPaymentLog] = useState(null);
  const [modal, setModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const toggleModal = () => {
    setSelectedPaymentLog(null);
    setModal(false);
  };

  const columns = useMemo(
    () => [
      {
        header: 'Customer Name',
        accessorKey: 'customerName',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Business Name',
        accessorKey: 'businessName',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Location Name',
        accessorKey: 'locationName',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: () => <div style={{ textAlign: 'center', width: '100%' }}>Status</div>,
        accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <div>
              <p
                style={{
                  background: cell.row.original.status.includes('Paid')
                    ? '#34C38F2E'
                    : cell.row.original.status === 'Failed'
                    ? 'rgba(128, 128, 128, 0.3)'
                    : 'rgba(255, 0, 0, 0.3)',
                  color: cell.row.original.status.includes('Paid')
                    ? '#34C38F'
                    : cell.row.original.status === 'Failed'
                    ? 'gray'
                    : 'rgba(255, 0, 0, 1)',
                  border: 0
                }}
                className="btn rounded-pill px-3 gap-1">
                {cell.row.original.status === 'Failed' ? null : cell.row.original.status.includes(
                    'Paid'
                  ) ? (
                  <i className="fa fa-arrow-down"></i>
                ) : (
                  <i className="fa fa-arrow-up"></i>
                )}
                &nbsp;{cell.row.original.status}
              </p>
            </div>
          );
        }
      },
      {
        header: 'Created At',
        accessorKey: 'createdAt',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => (
          <div className="d-flex gap-3 align-items-center ">
            <p className=" m-0">{cell.row.original.createdAt}</p>
          </div>
        )
      },
      {
        header: 'Error Code',
        accessorKey: 'errorCode',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Amount',
        accessorKey: 'amount',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => (
          <div className="d-flex gap-3 align-items-center ">
            <p className=" m-0">
              {cell?.row?.original?.amount?.toFixed(2) || ''} {cell.row.original.currency}
            </p>
          </div>
        )
      },
      {
        header: 'Card Brand',
        accessorKey: 'cardBrand',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: 'Last 4Digits',
        accessorKey: 'last4Digits',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: () => <div style={{ textAlign: 'center', width: '100%' }}>App Fee</div>,
        accessorKey: 'appFeeMoney',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => {
          return (
            <div>
              {cell?.row?.original?.fullPayload?.appFeeMoney && (
                <p
                  style={{
                    background: cell.row.original.status.includes('Paid')
                      ? '#34C38F2E'
                      : 'rgba(255, 0, 0,.3)',
                    color: cell.row.original.status.includes('Paid')
                      ? '#34C38F'
                      : 'rgba(255, 0, 0,1)',
                    border: 0
                  }}
                  className={`btn rounded-pill px-3 gap-1 `}>
                  {!cell.row.original.status.includes('Paid') ? (
                    <i className="fa fa-arrow-up"></i>
                  ) : (
                    <i className="fa fa-arrow-down"></i>
                  )}
                  &nbsp;{' '}
                  {(cell?.row?.original?.fullPayload?.appFeeMoney?.amount / 100)?.toFixed(2) || ''}{' '}
                  {cell?.row?.original?.fullPayload?.appFeeMoney?.currency}
                </p>
              )}
            </div>
          );
        }
      },
      {
        header: 'Appointment',
        accessorKey: 'appointmentId',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell) => (
          <p
            className="mb-0 text-dark"
            style={{
              color: '#000',
              cursor: 'pointer',
              fontSize: '13px',
              padding: 5
            }}
            onClick={() => {
              navigate(`/adminAppointment/${cell?.row?.original?.appointmentId}`);
            }}>
            View
          </p>
        )
      },
      {
        header: 'Action',
        cell: (cellProps) => (
          <div className="d-flex gap-2 align-items-center">
            {cellProps?.row?.original?.status !== 'Paid on Counter' && (
              <p
                onClick={() => {
                  setModal(true);
                  setSelectedPaymentLog(cellProps?.row?.original?.fullPayload);
                }}
                style={{
                  color: '#000',
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: 5
                }}
                className="m-0 text-dark">
                View
              </p>
            )}
          </div>
        )
      }
    ],
    [navigate]
  );

  useEffect(() => {
    localStorage.setItem('path', '/completepaymentlog');
    if (searchTerm === '') {
      getTransactionHistory(locationId, currentPage, pageSize);
    } else {
      let body = {
        searchString: searchTerm,
        locationId: parseInt(locationId),
        page: currentPage,
        limit: pageSize,
        startDate,
        endDate
      };
      searchData(body);
    }
  }, [locationId, currentPage, pageSize, searchTerm, startDate, endDate]);

  const searchData = async (body) => {
    try {
      const response = await getSerilizedCompletePaymentSearch(body);
      if (response?.data?.data?.data.length === 0 && response?.data?.data?.totalRecords > 0) {
        setCurrentPage(1);
      }
   //   setShowList([...baseList,response?.data?.data?.totalRecords])
      setData(response?.data?.data?.data);
      setTotalPages(response?.data?.data?.pages);
      setNext(response?.data?.data?.next);
      setPrev(response?.data?.data?.prev);
    } catch (error) {
      console.error('Fetch search error:', error);
    }
  };

  const getTransactionHistory = async (locationId, currentPage, pageSize) => {
    setLoader(true);
    setLoading(true);
   
    const response = await getSerilizedCompletePaymentLogs(
      currentPage,
      pageSize,
      startDate,
      endDate
    );
    if (response?.data?.data?.data.length === 0 && response?.data?.data?.totalRecords > 0) {
      setCurrentPage(1);
    }
   //   setShowList([...baseList,response?.data?.data?.totalRecords])
    setData(response?.data?.data?.data);
    setTotalPages(response?.data?.data?.pages);
    setNext(response?.data?.data?.next);
    setPrev(response?.data?.data?.prev);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // ✅ Export to Excel
  const handleExport = () => {
    if (!data || data.length === 0) {
      alert('No data available to export');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      data.map((item) => ({
        'Customer Name': item.customerName,
        'Business Name':item?.businessName,
        'Location Name':item?.locationName,
        Status: item.status,
        'Created At': item.createdAt,
        'Error Code': item.errorCode,
        Amount: item.amount?.toFixed(2) + ' ' + item.currency,
        'Card Brand': item.cardBrand,
        'Last 4 Digits': item.last4Digits,
        'App Fee': item.fullPayload?.appFeeMoney
          ? (item.fullPayload.appFeeMoney.amount / 100).toFixed(2) +
            ' ' +
            item.fullPayload.appFeeMoney.currency
          : '',
        'Appointment ID': item.appointmentId
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Payment Logs');
    XLSX.writeFile(workbook, 'Payment_Logs.xlsx');
  };

  return (
    <VerticalLayout>
      <React.Fragment>
        <div className="page-content">
          {loader ? (
            <Spinners setLoading={setLoader} />
          ) : (
            <>
              <div>
                <Container fluid>
                  <Breadcrumbs title="Payment Logs" breadcrumbItem="Payment Logs" />
                  {isLoading ? (
                    <Spinners setLoading={setLoading} timerStop={true} />
                  ) : (
                    <Row>
                      <Col lg="12">
                        <Card>
                          <CardBody>
                            {/* ✅ Export Button */}
                            <TableContainer
                              columns={columns}
                              data={data || []}
                              isGlobalFilter={true}
                              isPagination={true}
                              SearchPlaceholder="Search by transactionId, orderId, status, errorCode, last4Digits"
                              isCustomPageSize={true}
                              isAddButton={false}
                              buttonClass="btn btn-success rounded-pill addContact-modal mb-2"
                              buttonName="Add New Order"
                              tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                              theadClass="table-light"
                              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                              pagination="pagination"
                              isServerPagination={true}
                              onPageChange={handlePageChange}
                              ref={childRef}
                              currentPage={currentPage}
                              totalPages={totalPages}
                              pageSize={pageSize}
                              setPageSize={setPageSize}
                              next={next}
                              prev={prev}
                              setSearchTerm={setSearchTerm}
                              searchTerm={searchTerm}
                              serverSearching={true}
                              allowFilters={true}
                              allowCustomDateRange={true}
                              setStartDate={setStartDate}
                              setEndDate={setEndDate}
                              setFiletrValue={setFiletrValue}
                              filterValue={filterValue}
                              startDate={startDate}
                              endDate={endDate}
                              showDate={true}
                            //pageSizeOptions={showlist}
                              showExportButton={true}
                              ExportComponent={(<div className="d-flex justify-content-end">
                               <Button color="primary" onClick={handleExport} style={{borderColor:'black',paddingTop:9.5,paddingBottom:9.5}}>
                        Export to Excel
                      </Button>
                            </div>)}
                            />
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
              <ToastContainer />
            </>
          )}
        </div>

        {/* Modal for JSON Preview */}
        <Modal
          isOpen={modal}
          toggle={toggleModal}
          fullscreen
          style={{ width: 600, margin: '0px auto' }}
          centered>
          <ModalHeader toggle={toggleModal} tag="h4">
            Payment Logs
          </ModalHeader>
          <ModalBody>
            <JsonPreview data={selectedPaymentLog} />
          </ModalBody>
        </Modal>
      </React.Fragment>
    </VerticalLayout>
  );
};

export default withRouter(CompletePaymentLog);
